import React from 'react';
import { Link } from 'react-router-dom';
import Card from '../../common/Card';
import StatusBadge from '../StatusBadge';
import { extractNumericId } from '../../utils/formatters';
import './styles.css';

/**
 * 保養單卡片組件
 * 用於顯示保養單信息
 * 
 * @param {Object} props - 組件屬性
 * @param {Object} props.warranty - 保養單數據
 * @param {Function} props.formatDate - 日期格式化函數
 * @param {string} props.className - 額外的CSS類名
 * @returns {JSX.Element} 保養單卡片組件
 */
function WarrantyCard({
    warranty,
    formatDate = (date) => date,
    className = ''
}) {
    if (!warranty) return null;

    // 格式化產品名稱
    const formatProductName = (productName) => {
        if (!productName) return '未設置';
        return productName.length > 30 ? productName.substring(0, 30) + '...' : productName;
    };

    return (
        <Card className={`warranty-card ${className}`}>
            <div className="warranty-card-header">
                <StatusBadge status={warranty.verification_status} />
                <Link to={`/warranties/${extractNumericId(warranty.id)}`} className="warranty-card-link">
                    查看詳情
                </Link>
            </div>

            <div className="warranty-card-content">
                <div className="warranty-card-info">
                    <p><strong>產品名稱:</strong> {formatProductName(warranty.product_name) || '未設置'}</p>
                    {/* <p><strong>客戶姓名:</strong> {warranty.customer_name || '未設置'}</p> */}
                    {/* <p><strong>聯絡電話:</strong> {warranty.phone || '未設置'}</p> */}
                    <p><strong>購買日期:</strong> {formatDate(warranty.purchase_date)}</p>
                    <p><strong>保修到期日:</strong> {formatDate(warranty.warranty_expiration_date)}</p>
                    {warranty.warranty_period && <p><strong>保修期:</strong> {warranty.warranty_period} 年</p>}
                </div>

                {warranty.verification_status !== 'Pending' && (
                    <div className="warranty-card-verification">
                        <p><strong>驗證日期:</strong> {formatDate(warranty.verification_date)}</p>
                        <p><strong>驗證人員:</strong> {warranty.staff_name || '未記錄'}</p>
                        {warranty.verification_status === 'Rejected' && warranty.verification_notes && (
                            <p><strong>拒絕原因:</strong> {warranty.verification_notes}</p>
                        )}
                    </div>
                )}
            </div>
        </Card>
    );
}

export default WarrantyCard; 